import axios from 'axios'

export const fetchTenantAgreement = (supplierId) =>
  axios
    .get(`/authenticated/supplier/${supplierId}/tenant-agreement`)
    .then((res) => res.data)

export const downloadTenantAgreementDocument = (
  supplierId,
  documentId,
  inline
) =>
  axios
    .get(`/authenticated/supplier/${supplierId}/tenant-agreement/document`, {
      params: { documentId, inline },
      responseType: 'blob'
    })
    .then((res) => res.data)
